var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-overlay',{attrs:{"show":_vm.isLoading}},[_c('line-chart',{attrs:{"data":_vm.chartData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }